"use strict";
var core_1 = require('@angular/core');
var RioButton = (function () {
    function RioButton() {
        this.onClick = new core_1.EventEmitter();
    }
    RioButton.prototype.handleClick = function (event) {
        this.onClick.emit(event);
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], RioButton.prototype, "className", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], RioButton.prototype, "type", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], RioButton.prototype, "qaid", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], RioButton.prototype, "disabled", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], RioButton.prototype, "onClick", void 0);
    RioButton = __decorate([
        core_1.Component({
            selector: 'rio-button',
            template: "\n    <button\n      [id]=\"qaid\"\n      (click)=\"handleClick($event)\"\n      [disabled]=\"disabled\"\n      type=\"{{type || 'button'}}\"\n      class=\"btn btn-primary {{className}}\">\n\n      <ng-content></ng-content>\n    </button>\n  "
        }), 
        __metadata('design:paramtypes', [])
    ], RioButton);
    return RioButton;
}());
exports.RioButton = RioButton;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEscUJBQXVELGVBQWUsQ0FBQyxDQUFBO0FBZ0J2RTtJQUFBO1FBS1ksWUFBTyxHQUFHLElBQUksbUJBQVksRUFBUyxDQUFDO0lBS2hELENBQUM7SUFIQywrQkFBVyxHQUFYLFVBQVksS0FBSztRQUNmLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQzNCLENBQUM7SUFSRDtRQUFDLFlBQUssRUFBRTs7Z0RBQUE7SUFDUjtRQUFDLFlBQUssRUFBRTs7MkNBQUE7SUFDUjtRQUFDLFlBQUssRUFBRTs7MkNBQUE7SUFDUjtRQUFDLFlBQUssRUFBRTs7K0NBQUE7SUFDUjtRQUFDLGFBQU0sRUFBRTs7OENBQUE7SUFuQlg7UUFBQyxnQkFBUyxDQUFDO1lBQ1QsUUFBUSxFQUFFLFlBQVk7WUFDdEIsUUFBUSxFQUFFLHFQQVVUO1NBQ0YsQ0FBQzs7aUJBQUE7SUFXRixnQkFBQztBQUFELENBQUMsQUFWRCxJQVVDO0FBVlksaUJBQVMsWUFVckIsQ0FBQTtBQUFBLENBQUMifQ==


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/button/index.ts
 ** module id = 272
 ** module chunks = 1
 **/